const showRemainingToursBtn = document.querySelector("[data-tour-remaining]");
const hiddenTourDates = document.querySelector("[data-hidden-stops]");

showRemainingToursBtn?.addEventListener("click", (e) => {
  e.preventDefault();

  isExpanded = hiddenTourDates?.getAttribute("data-expanded");

  if (isExpanded === "false") {
    expandContentHeight(hiddenTourDates);
    showRemainingToursBtn.textContent = "Show Less";
    hiddenTourDates.setAttribute("data-expanded", "true");
  } else {
    collapseContentHeight(hiddenTourDates);
    showRemainingToursBtn.textContent = "View All Tour Locations";
    hiddenTourDates.setAttribute("data-expanded", "false");
  }
});

function expandContentHeight(element) {
  let sectionHeight = element.scrollHeight;

  element.style.height = sectionHeight + "px";
}

function collapseContentHeight(element) {
  element.style.height = 0 + "px";
}

const esgCurrentPage = document.querySelector("[data-esg-current]");
const esgNav = document.querySelector("[data-esg-nav]");

if (esgCurrentPage) {
  esgCurrentPage.addEventListener("click", () => {
    const esgIcon = document.querySelector("[data-esg-current] > svg");

    if (esgNav.dataset.esgNav === "closed") {
      esgNav.dataset.esgNav = "open";
      esgIcon.dataset.icon = "times";
    } else {
      esgNav.dataset.esgNav = "closed";
      esgIcon.dataset.icon = "angle-down";
    }
  });
}

// Locations JS
const detailElements = document.querySelectorAll("details");

/* Modals */
const cardModal = document.querySelector("[data-modal-content]");
const videoModal = document.querySelector("[data-video-modal]");
const videoFrame = document.querySelector("[data-video-frame]");

document.addEventListener(
  "click",
  function (e) {
    if (e.target.matches("[data-location]")) {
      let locationId = e.target.getAttribute("data-location");

      if (!locationId) return;

      // Close all details
      detailElements?.forEach((detail) => {
        detail.removeAttribute("open");
      });

      // Get previously selected element and remove class
      let selected = document.getElementsByClassName("selected-location")[0];
      selected?.classList.toggle("selected-location");

      // Find offices div by ID
      let selectedState = document.getElementById(locationId);
      selectedState.classList.toggle("selected-location");
      selectedState.scrollIntoView("smooth");
    }

    // Modal for cards
    if (e.target.matches("[data-modal-card]")) {
      let modal = cardModal;
      let cardCopy = e.target.parentNode.querySelector("[data-modal-copy]");
      let cardTitle = e.target.parentNode.querySelector("[data-modal-title]");
      let article = modal.querySelector("article");
      let title = modal.querySelector("h2");

      title.textContent = cardTitle.textContent;
      article.innerHTML = cardCopy.innerHTML;

      document.body.classList.add("modal-opened");
      modal.classList.add("visible-modal");
    }

    // Modal for videos
    if (e.target.matches("[data-video-id]")) {
      let modal = videoModal;
      let videoTitle = e.target.nextElementSibling;
      let title = modal.querySelector("h2");

      title.textContent = videoTitle?.textContent;
      document.body.classList.add("modal-opened");
      modal.classList.add("visible-modal");
      videoFrame.setAttribute(
        "src",
        "https://player.vimeo.com/video/" +
        e.target.dataset.videoId +
        "?&portrait=0&byline=0"
      );
    }

    // Close modals
    if (
      e.target.parentNode.matches("[data-close-video-modal]") ||
      e.target.parentNode.matches("[data-close-card-modal]")
    ) {
      closeModal();
    }

    // Category selector for blog
    if (e.target.matches("[data-category-selector-btn]")) {
      document
        .querySelector("[data-category-selector-list]")
        .classList.toggle("show");

      const icon = e.target.firstElementChild;

      if (icon.classList.contains("fa-bars")) {
        icon.classList.remove("fa-bars");
        icon.classList.add("fa-times");
      } else {
        icon.classList.remove("fa-times");
        icon.classList.add("fa-bars");
      }
    }
  },
  false
);

document.addEventListener("keyup", (e) => {
  if (e.key === "Escape") {
    closeModal();
  }
});

function resetModalData() {
  let modal = document.querySelector(".visible-modal");
  let article = modal.querySelector("article");
  let title = modal.querySelector("h2");

  title.textContent = "";
  if (modal.hasAttribute("data-video-modal")) {
    videoFrame.setAttribute("src", "");
  } else {
    article.innerHTML = "";
  }
  modal.classList.remove("visible-modal");
}

function closeModal() {
  resetModalData();
  document.body.classList.remove("modal-opened");
}

// Toggle password field for locked pages
const passIcon = document.querySelector(".post-password-form button");

passIcon?.addEventListener("click", () => {
  //const icon = passIcon.children[0];
  const icon = passIcon.querySelector("svg");
  const formField = document.querySelector(
    '.post-password-form input[name="post_password"]'
  );

  if (icon.classList.contains("fa-eye")) {
    icon.classList.remove("fa-eye");
    icon.classList.add("fa-eye-slash");
    formField.type = "text";
  } else {
    icon.classList.remove("fa-eye-slash");
    icon.classList.add("fa-eye");
    formField.type = "password";
  }
});

const copyArticleButton = document.querySelector("[data-copy-article-url]");

copyArticleButton?.addEventListener("click", () => {
  navigator.clipboard.writeText(window.location.href);
  document
    .querySelector(".entry-meta-grid")
    .insertAdjacentHTML(
      "afterend",
      '<div class="linktooltips-container" style="text-align:center;font-size: 1rem;font-weight: 400;">Link copied</div>'
    );
  setTimeout(() => {
    document
      .querySelectorAll(".linktooltips-container")
      .forEach((el) => el.remove());
  }, 3000);
});

